<template>
    <div>
        <form>
            <div class="row">
                <div class="col-sm-2">
                    <div class="mb-3">
                        <label>No. Empleado</label>
                        <input class="form-control" type="text" placeholder="" v-model="form.employee_number" v-bind:class="formSubmitted ? errors.employee_number ? 'is-invalid' : 'is-valid' : ''">
                        <div class="invalid-feedback" v-if="errors.employee_number != false">{{ errors.employee_number }}</div>
                    </div>
                </div>
                <div class="col-sm-4">
                    <div class="mb-3">
                        <label>Patrón</label>
                        <select class="form-select" v-model="form.employer_id">
                            <option v-for="(employer, index) in employers" :key="index" :value="employer.id">{{ employer.name }}</option>
                        </select>
                    </div>
                </div>
                <div class="col-sm-3">
                    <div class="mb-3">
                        <label>Puesto:</label>
                        <select class="form-select" v-model="form.employee_position_id" v-bind:class="formSubmitted ? errors.employee_position_id ? 'is-invalid' : 'is-valid' : ''">
                            <option v-for="(job_position, index) in job_positions" :key="index" :value="job_position.id">{{ job_position.name }}</option>
                        </select>
                        <div class="invalid-feedback" v-if="errors.employee_position_id != false">{{ errors.employee_position_id }}</div>
                    </div>
                </div>
                <div class="col-sm-3">
                    <div class="mb-3">
                        <label>Fecha de Ingreso</label>
                        <Datepicker class="datepicker-here form-control digits dp2" v-model="form.contract_date" :enable-time-picker="false" :locale="'es-MX'" :format-locale="es" format="dd/MM/yyyy"></Datepicker>
                    </div>
                </div>
            </div>
            <div class="row">  
                <div class="col-sm-4">
                    <div class="mb-3">
                        <label class="form-label">Jefe Inmediato</label>
                        <select class="form-select" v-model="form.employee_boss_id">
                            <option v-for="(boss, index) in bosses" :key="index" :value="boss.id">{{ boss.name }}</option>
                        </select>
                    </div>
                </div>
                <div class="col-sm-2">
                    <div class="mb-3">
                        <label>Días de Trabajo (Quincena)</label>
                        <input class="form-control" type="text" placeholder="" v-model="form.total_work_days" v-bind:class="formSubmitted ? errors.total_work_days ? 'is-invalid' : 'is-valid' : ''">
                        <div class="invalid-feedback" v-if="errors.total_work_days != false">{{ errors.total_work_days }}</div>
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="mb-3">
                        <table class="rest_days" style="width: 100%; margin-top: 6px;">
                            <tr>
                                <th colspan="8" style="font-weight: normal;">Jornada Laboral</th>
                                <th></th>
                                <th style="font-weight: normal;">Horario</th>
                            </tr>
                            <tr>
                                <td style="width: 50px;"></td>
                                <td>Lun</td>
                                <td>Mar</td>
                                <td>Mie</td>
                                <td>Jue</td>
                                <td>Vie</td>
                                <td>Sab</td>
                                <td>Dom</td>
                                <td rowspan="2" style="width: 50px;"></td>
                                <td rowspan="2">
                                    <select class="form-select" v-model="form.start_hour">
                                        <option value="07:00">07:00</option>
                                        <option value="08:00">08:00</option>
                                        <option value="09:00">09:00</option>
                                        <option value="10:00">10:00</option>
                                        <option value="11:00">11:00</option>
                                        <option value="12:00">12:00</option>
                                        <option value="13:00">13:00</option>
                                        <option value="14:00">14:00</option>
                                        <option value="15:00">15:00</option>
                                        <option value="16:00">16:00</option>
                                        <option value="17:00">17:00</option>
                                        <option value="18:00">18:00</option>
                                        <option value="19:00">19:00</option>
                                        <option value="20:00">20:00</option>
                                    </select>
                                </td>
                                <td rowspan="2" style="width: 10px;"></td>
                                <td rowspan="2">
                                    <select class="form-select" v-model="form.end_hour">
                                        <option value="07:00">07:00</option>
                                        <option value="08:00">08:00</option>
                                        <option value="09:00">09:00</option>
                                        <option value="10:00">10:00</option>
                                        <option value="11:00">11:00</option>
                                        <option value="12:00">12:00</option>
                                        <option value="13:00">13:00</option>
                                        <option value="14:00">14:00</option>
                                        <option value="15:00">15:00</option>
                                        <option value="16:00">16:00</option>
                                        <option value="17:00">17:00</option>
                                        <option value="18:00">18:00</option>
                                        <option value="19:00">19:00</option>
                                        <option value="20:00">20:00</option>
                                    </select>
                                </td>
                            </tr>
                            <tr>
                                <td style="width: 50px;"></td>
                                <td><input type="checkbox" v-model="form.rest_day_1" /></td>
                                <td><input type="checkbox" v-model="form.rest_day_2" /></td>
                                <td><input type="checkbox" v-model="form.rest_day_3" /></td>
                                <td><input type="checkbox" v-model="form.rest_day_4" /></td>
                                <td><input type="checkbox" v-model="form.rest_day_5" /></td>
                                <td><input type="checkbox" v-model="form.rest_day_6" /></td>
                                <td><input type="checkbox" v-model="form.rest_day_7" /></td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>
            <div class="row">  
                <div class="col-sm-4">
                    <div class="mb-3">
                        <label>Bono de Productividad</label>
                        <input class="form-control" type="text" placeholder="" v-model="form.bono_amount" v-bind:class="formSubmitted ? errors.bono_amount ? 'is-invalid' : 'is-valid' : ''">
                        <div class="invalid-feedback" v-if="errors.bono_amount != false">{{ errors.bono_amount }}</div>
                    </div>
                </div>
                <div class="col-sm-4">
                    <div class="mb-3">
                        <label>Frecuencia del Bono</label>
                        <select class="form-select" v-model="form.bono_frecuency">
                            <option value="MENSUAL">MENSUAL</option>
                            <option value="QUINCENAL">QUINCENAL</option>
                        </select>
                    </div>
                </div>
                <div class="col-sm-4">
                    <div class="mb-3">
                        <label>Sueldo</label>
                        <input class="form-control" type="text" v-model="form.final_wage" placeholder="" v-bind:class="formSubmitted ? errors.final_wage ? 'is-invalid' : 'is-valid' : ''">
                        <div class="invalid-feedback" v-if="errors.final_wage != false">{{ errors.final_wage }}</div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>
<script>

import validations from "@/mixins/validations/employeeValidations";
import modalCleanupMixin from '@/mixins/commen/modalCleanupMixin';

import Datepicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'
import { es } from 'date-fns/locale'

import ws from '@/services/employees'

export default {
    name: 'employee_contract_tab',
    mixins: [validations, modalCleanupMixin],
    components: {
        Datepicker
    },
    data(){
        return{
            employee: null,
            employers: [],
            job_positions: [],
            bosses: []
        }
    },
    methods: {
        async loadEmployee(employee){
            this.employee = employee;

            let response = await ws.getEmployers(); 

            if(response.type == "success"){
                this.employers = response.data;
            }

            let response2 = await ws.getPositions(); 

            if(response2.type == "success"){
                this.job_positions = response2.data;
            }

            let response3 = await ws.getBosses(); 

            if(response3.type == "success"){
                this.bosses = response3.data;
            }

            this.setForm(this.employee);
        },
        async updateContractEmployee(form) {
            let response = await ws.updateEmployee(form);

            if(response.type == "success"){
                this.$toast.success(response.message);

                this.$emit('refresh', response.data);
            }
            else{
                this.$toast.error(response.message);
            }
        },
        validations(){
            this.updateEmployeeContractValidation();
        }
    }
}
</script>
<style>
    .dp2{
        input {
            height: 28px;
        }
    }
</style>

<style scoped>
    .container-fluid {
        padding-top: 20px;
    }

    .title{
        font-size: 28px;
    }

    .datepicker-here{
        padding: 0.25rem 0.75rem;
    }

    .rest_days{
        margin-left: 10px;
        float: left;
    }

    .rest_days td{
        padding-right: 8px;
        text-align: center;
    }

    .rest_days th{
        padding-right: 8px;
        text-align: left;
    }

    .infonavit td{
        text-align: center;
    }
</style>